// extracted by mini-css-extract-plugin
export var fadeInOut = "_4c-3";
export var icon = "_4c-4";
export var savedIndicator = "_4c-2";
export var savingIndicator = "_4c-0";
export var spin = "_4c-1";